import { GET, POST, PUT } from '../request'

export const getFormaciones = year =>
  GET('/api/core/formacion/formacion/list/year', { year })
export const createFormaciones = ({ nombre, centro, email }) =>
  POST('/api/core/formacion/formacion', { nombre, centro, email })
export const updateFormaciones = ({ id, nombre, centro, email, completada }) =>
  PUT('/api/core/formacion/formacion', {
    id,
    nombre,
    centro,
    email,
    completada
  })
